<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" class="cadastre-building" :no-close-on-esc="true"
             :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">

                    <div class="form-group">
                        <label>Ижарага бериладиган майдонларнинг умумий номи <span class="red">*</span></label>
                        <v-select v-model="data.purposesRentingAreasId" label="name"
                                  :options="purposesRentingAreas"
                                  :filterable="false"
                                  @search="onPurposesRentingAreasSearch"
                                  @search:focus="onPurposesRentingAreasFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>

                    <div class="form-group">
                        <label>Номи <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingFieldReferenceEdit.nameUz")}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import {required} from 'vuelidate/lib/validators'

    export default {
        name: "PurposesRentingAreasAddEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                parentFilter: initFilterModel(),
                data: this.initEmptyData(),
                purposesRentingAreas: []
            }
        },
        validations: {
            data: {
                purposesRentingAreasId: {
                    required
                },
                name: {
                    required
                }
            }
        },
        methods: {
            initEmptyData() {
                return {
                    name: '',
                    purposesRentingAreasId: null
                }
            },

            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.data.purposesRentingAreasId = this.data.purposesRentingAreasId.id;

                this.$http.post('rental-rates/purposes-renting-areas-item/save', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        console.log(response.status);
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('purposesRentingAreasItemChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            onPurposesRentingAreasSearch(searchTxt, loading) {
                loading(true);
                this.purposesRentingAreas = [];
                this.parentFilter.search = searchTxt;
                this.$http.post('rental-rates/purposes-renting-areas/lookUp', this.parentFilter)
                    .then(res => {
                        this.purposesRentingAreas = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onPurposesRentingAreasFocus() {
                this.purposesRentingAreas = [];
                this.parentFilter.search = '';
                this.$http.post('rental-rates/purposes-renting-areas/lookUp', this.parentFilter)
                    .then(res => {
                        this.purposesRentingAreas = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }

        },
        created() {
            this.parentFilter.page.size = 1000;
            this.$eventBus.$on('showPurposesRentingAreasItemAddEditModal', (data) => {
                if (data) {
                    this.data = clone(data);
                } else {
                    this.data = this.initEmptyData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>
